import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import EmailLogList from "./partials/EmailLogList";
import { Route, Routes } from "react-router-dom";
import { Toast } from "primereact/toast";
import qs from "qs";
import { getFromStorage, setToStorage } from "../../../utils/Helper";
import { isEmpty } from "lodash";
import UrlHelper from "js-url-helper";

const url = new UrlHelper();

const EmailLog = (props: any) => {
    const { t } = props;
    const toast = useRef(null);
    const [dropdowns, setDropdowns] = useState<any>(null);
    const [moduleState, setModuleState] = useState<any>({
        page: 1,
        per_page: 200,
        search: null,
        initialized: false,
        sort_field: null,
        sort_order: null,
    });

    useEffect(() => {
        document.title = t("email logs");

        const prevUrl = qs.parse(url.getSearchParam().prev_url ?? "");
        const fromStorage: any = getFromStorage('supplierEmailLogsModuleState');
        const defaultState = {
            page: !isEmpty(prevUrl.page) ? url.getSearchParam().page : 1,
            per_page: !isEmpty(prevUrl.per_page) ? url.getSearchParam().per_page : 20,
            search: !isEmpty(prevUrl.search) ? url.getSearchParam().search : null,
            initialized: true,
            sort_field: null,
            sort_order: null,
            ...(!isEmpty(fromStorage) ? JSON.parse(fromStorage) : {})
        }

        setModuleState(defaultState);
        setToStorage('supplierEmailLogsModuleState', JSON.stringify(defaultState));

    }, []);

    const toastify = (message: any, color: string = 'info', summary: any = null) => {
        if ( toast && toast.current ) {
            // @ts-ignore
            toast.current.show({ severity: color, summary: summary, detail: message });
        }
    };

    const setQuery = (value: any) => {
        setToStorage('supplierEmailLogsModuleState', JSON.stringify(value));
        setModuleState(value);
    }

    return (
        <div className={ "module-container" }>
            <Toast ref={ toast } />
            <div className="layout-content">
                { ( moduleState && moduleState.initialized ) ?
                    <React.Fragment>
                        <Routes>
                            <Route path={ "/" } element={
                                <EmailLogList
                                    moduleState={ moduleState }
                                    dropdowns={ dropdowns }
                                    toastify={ toastify }
                                    setQuery={ setQuery }
                                /> } />
                        </Routes>
                    </React.Fragment>
                    : <h6>{ t('loading') }</h6> }
            </div>
        </div>
    );
};

// EmailLog.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(EmailLog);
